import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TAddressDM from './TAddressDM'
import TContactPersonDM from './TContactPersonDM'
import TTradingPartnerDM from './TTradingPartnerDM'
import TK2UserLookupDM from './TK2UserLookupDM'
import TDeliveryPlanItemBookDM from './TDeliveryPlanItemBookDM'
import TDeviceDocumentDM from './TDeviceDocumentDM'
import TOfficerDocumentDM from './TOfficerDocumentDM'
import TArticleCodeDocumentDM from './TArticleCodeDocumentDM'
import TContractCodeDocumentDM from './TContractCodeDocumentDM'
import TCode6DocumentDM from './TCode6DocumentDM'
import TCode5DocumentDM from './TCode5DocumentDM'
import TCode4DocumentDM from './TCode4DocumentDM'
import TCode3DocumentDM from './TCode3DocumentDM'
import TCode2DocumentDM from './TCode2DocumentDM'
import TCode1DocumentDM from './TCode1DocumentDM'
import TCostCentreCollectionDocumentDM from './TCostCentreCollectionDocumentDM'
import TermOfDelivery from './TermOfDelivery'
import TTextDM from './TTextDM'
import TTownDM from './TTownDM'
import TTownPartDM from './TTownPartDM'
import TCountryDM from './TCountryDM'
import TDeliveryNoteDM from './TDeliveryNoteDM'
import TDeliveryConfirmationDM from './TDeliveryConfirmationDM'
import TInvoiceInDM from './TInvoiceInDM'
import TInvoiceOutDM from './TInvoiceOutDM'
import TPurchaseOrderDM from './TPurchaseOrderDM'
import TReceiptCardDM from './TReceiptCardDM'
import TTransferNoteDM from './TTransferNoteDM'
import TReservingCardDM from './TReservingCardDM'
import TReleaseNoteDM from './TReleaseNoteDM'
import TSalesOrderDM from './TSalesOrderDM'
import TDeliveryMeasureUnitDM from './TDeliveryMeasureUnitDM'

/**
 * Položky rozvozu
 */
export default class TDeliveryOrderItemDM extends Data {
	public static className = 'TDeliveryOrderItemDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Pořadí vykládky
	 */
	UnloadingSequenceNumber?: number

	/**
	 * Pořadí nakládky
	 */
	LoadingSequenceNumber?: number

	/**
	 * Objem
	 */
	Volume?: number

	/**
	 * Potvrzení
	 */
	ConfirmedOn?: Date

	/**
	 * Potvrdil
	 */
	ConfirmedById?: number

	/**
	 * Hmotnost
	 */
	Weight?: number

	/**
	 * Sklad vykládka
	 */
	WarehouseToId?: number

	/**
	 * Sklad nakládka
	 */
	WarehouseFromId?: number

	/**
	 * Balení
	 */
	PackageId?: string

	/**
	 * Region
	 */
	RegionId?: number

	/**
	 * Email vykládka
	 */
	EmailTo?: string

	/**
	 * Email nakládka
	 */
	EmailFrom?: string

	/**
	 * Tel. vykládka
	 */
	PhoneTo?: string

	/**
	 * Tel. nakládka
	 */
	PhoneFrom?: string

	/**
	 * Poznámka
	 */
	Note?: string

	/**
	 * Vytvořeno
	 */
	CreatedOn?: Date

	/**
	 * Popis
	 */
	Description?: string

	/**
	 * Typ rozvozu
	 */
	HeaderTypeId?: number

	/**
	 * Stornováno
	 */
	IsCanceledRecord?: string

	/**
	 * Termín dodání
	 */
	DeliveryTime?: Date

	/**
	 * Změněno
	 */
	ChangedOn?: Date

	/**
	 * Doklad
	 */
	OriginalDocumentRID?: number

	/**
	 * Pořadí
	 */
	SequenceNumber?: number

	/**
	 * Rozvoz
	 */
	HeaderRID?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * Souřadnice (Adresa vykládky)
	 */
	AddressToIdCoordinates?: string

	/**
	 * PSČ (Adresa vykládky)
	 */
	AddressToIdTownCode?: string

	/**
	 * undefined
	 */
	AddressToIdChanged?: number

	/**
	 * Název (Adresa vykládky)
	 */
	AddressToIdName?: string

	/**
	 * Číslo popisné (Adresa vykládky)
	 */
	AddressToIdHouseNumber?: string

	/**
	 * Číslo orientační (Adresa vykládky)
	 */
	AddressToIdOrientationNumber?: string

	/**
	 * Ulice (Adresa vykládky)
	 */
	AddressToIdStreet?: string

	/**
	 * Souřadnice (Adresa nakládky)
	 */
	AddressFromIdCoordinates?: string

	/**
	 * PSČ (Adresa nakládky)
	 */
	AddressFromIdTownCode?: string

	/**
	 * undefined
	 */
	AddressFromIdChanged?: number

	/**
	 * Název (Adresa nakládky)
	 */
	AddressFromIdName?: string

	/**
	 * Číslo popisné (Adresa nakládky)
	 */
	AddressFromIdHouseNumber?: string

	/**
	 * Číslo orientační (Adresa nakládky)
	 */
	AddressFromIdOrientationNumber?: string

	/**
	 * Ulice (Adresa nakládky)
	 */
	AddressFromIdStreet?: string

	/**
	 * undefined
	 */
	SequenceNumberLineId?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * undefined
	 */
	DocumentIdentificationCalc?: string

	/**
	 * undefined
	 */
	DeliveryTimeDateCalc?: Date

	/**
	 * undefined
	 */
	DeliveryTimeTimeCalc?: Date

	/**
	 * undefined
	 */
	ActualWeightCalc?: number

	/**
	 * undefined
	 */
	TotalVolumePARAMCalc?: number

	/**
	 * Adresa vykládky
	 */
	@Type(() => TAddressDM)
	AddressToId?: TAddressDM

	/**
	 * Adresa nakládky
	 */
	@Type(() => TAddressDM)
	AddressFromId?: TAddressDM

	/**
	 * Kontaktní osoba vykládka
	 */
	@Type(() => TContactPersonDM)
	ContactPersonToId?: TContactPersonDM

	/**
	 * Kontaktní osoba vykládka
	 */
	@Type(() => TContactPersonDM)
	ContactPersonFromId?: TContactPersonDM

	/**
	 * Zákazník vykládka
	 */
	@Type(() => TTradingPartnerDM)
	TradingPartnerToId?: TTradingPartnerDM

	/**
	 * Zákazník nakládka
	 */
	@Type(() => TTradingPartnerDM)
	TradingPartnerFromId?: TTradingPartnerDM

	/**
	 * Vytvořil
	 */
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM

	/**
	 * Položka rozvozu
	 */
	@Type(() => TDeliveryPlanItemBookDM)
	DeliveryPlanItemRID?: TDeliveryPlanItemBookDM

	/**
	 * Prostředek
	 */
	@Type(() => TDeviceDocumentDM)
	DeviceRID?: TDeviceDocumentDM

	/**
	 * Referent
	 */
	@Type(() => TOfficerDocumentDM)
	OfficerId?: TOfficerDocumentDM

	/**
	 * Kód zboží
	 */
	@Type(() => TArticleCodeDocumentDM)
	ArticleCodeId?: TArticleCodeDocumentDM

	/**
	 * Kód zakázky
	 */
	@Type(() => TContractCodeDocumentDM)
	ContractCodeRID?: TContractCodeDocumentDM

	/**
	 * Kód 6
	 */
	@Type(() => TCode6DocumentDM)
	Code6Id?: TCode6DocumentDM

	/**
	 * Kód 5
	 */
	@Type(() => TCode5DocumentDM)
	Code5Id?: TCode5DocumentDM

	/**
	 * Kód 4
	 */
	@Type(() => TCode4DocumentDM)
	Code4Id?: TCode4DocumentDM

	/**
	 * Kód 3
	 */
	@Type(() => TCode3DocumentDM)
	Code3Id?: TCode3DocumentDM

	/**
	 * Kód 2
	 */
	@Type(() => TCode2DocumentDM)
	Code2Id?: TCode2DocumentDM

	/**
	 * Kód 1
	 */
	@Type(() => TCode1DocumentDM)
	Code1Id?: TCode1DocumentDM

	/**
	 * Středisko
	 */
	@Type(() => TCostCentreCollectionDocumentDM)
	CostCentreId?: TCostCentreCollectionDocumentDM

	/**
	 * Termín dodání slovy
	 */
	@Type(() => TermOfDelivery)
	DeliveryTimeText?: TermOfDelivery

	/**
	 * Změnil
	 */
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM

	/**
	 * Typ dokladu
	 */
	@Type(() => TTextDM)
	OriginalDocumentTypeId?: TTextDM

	/**
	 * Číslo (Adresa vykládky)
	 */
	@Type(() => TTownDM)
	AddressToIdTownId?: TTownDM

	/**
	 * Část obce (Adresa vykládky)
	 */
	@Type(() => TTownPartDM)
	AddressToIdTownPartId?: TTownPartDM

	/**
	 * Stát (Adresa vykládky)
	 */
	@Type(() => TCountryDM)
	AddressToIdCountryId?: TCountryDM

	/**
	 * Číslo (Adresa nakládky)
	 */
	@Type(() => TTownDM)
	AddressFromIdTownId?: TTownDM

	/**
	 * Část obce (Adresa nakládky)
	 */
	@Type(() => TTownPartDM)
	AddressFromIdTownPartId?: TTownPartDM

	/**
	 * Stát (Adresa nakládky)
	 */
	@Type(() => TCountryDM)
	AddressFromIdCountryId?: TCountryDM

	/**
	 * undefined
	 */
	@Type(() => TTextDM)
	ConfirmedOrCanceledIdCalc?: TTextDM

	/**
	 * undefined
	 */
	@Type(() => TTradingPartnerDM)
	DocumentTradingPartnerIdCalc?: TTradingPartnerDM

	/**
	 * undefined
	 */
	@Type(() => TTradingPartnerDM)
	DocumentDeliveryTradingPartnerIdCalc?: TTradingPartnerDM

	/**
	 * Dodaci list
	 */
	@Type(() => TDeliveryNoteDM)
	DeliveryNoteRIDCalc?: TDeliveryNoteDM

	/**
	 * Potvrzení dodání
	 */
	@Type(() => TDeliveryConfirmationDM)
	DeliveryConfirmationRIDCalc?: TDeliveryConfirmationDM

	/**
	 * Faktura přijatá
	 */
	@Type(() => TInvoiceInDM)
	InvoiceInRIDCalc?: TInvoiceInDM

	/**
	 * Faktura vydaná
	 */
	@Type(() => TInvoiceOutDM)
	InvoiceOutRIDCalc?: TInvoiceOutDM

	/**
	 * Objednávka
	 */
	@Type(() => TPurchaseOrderDM)
	PurchaseOrderRIDCalc?: TPurchaseOrderDM

	/**
	 * Příjemka
	 */
	@Type(() => TReceiptCardDM)
	ReceiptCardRIDCalc?: TReceiptCardDM

	/**
	 * Převodka
	 */
	@Type(() => TTransferNoteDM)
	TransferNoteRIDCalc?: TTransferNoteDM

	/**
	 * Rezervační list
	 */
	@Type(() => TReservingCardDM)
	ReservingCardRIDCalc?: TReservingCardDM

	/**
	 * Výdejka
	 */
	@Type(() => TReleaseNoteDM)
	ReleaseNoteRIDCalc?: TReleaseNoteDM

	/**
	 * Zakázka
	 */
	@Type(() => TSalesOrderDM)
	SalesOrderRIDCalc?: TSalesOrderDM

	/**
	 * undefined
	 */
	@Type(() => TDeliveryMeasureUnitDM)
	MeasureUnitChild?: TDeliveryMeasureUnitDM[]
}